import { AnimationData } from 'featureSliced/shared/utils/animations'

export const loadAnimation = async (
  path: string,
  onError?: (error: Error) => void
): Promise<AnimationData | null> => {
  try {
    const animation = await import(`assets/lotties/${path}`)
    return animation.default
  } catch (error) {
    if (onError) {
      onError(error as Error)
    } else {
      console.error(`Failed to load animation from ${path}:`, error)
    }
    return null
  }
}
